import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { FilterContentTypes, LISTER_TILES_DEFAULT_SIZE, } from '@as-react/common-types';
import { useIsClient } from '@yonderland/andes-react';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Events } from '../../enums/AnalyticsEnums';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import compareActions from '../../redux/compare/actions/CompareActions.creators';
import { listerActions } from '../../redux/lister/actions/ListerActions.creators';
import MonetateUtil from '../../util/MonetateUtil';
import { getListerItemsToShow } from '../../util/ProductListerUtil';
import { useProductListerContext } from '../product-lister/context/ProductListerContext';
import { ProductListerGrid } from './ProductListerGrid';
export const ProductListerResults = () => {
    const isClient = useIsClient();
    const { pageInfo, currency } = useAemConfig();
    const { query: { data, isFetching, isFetched }, contentBlocks, urlState, filterState: { activeFilters }, } = useProductListerContext();
    const dispatch = useDispatch();
    const itemsToShow = getListerItemsToShow((data === null || data === void 0 ? void 0 : data.items) || [], LISTER_TILES_DEFAULT_SIZE, isClient);
    const singleActiveSizeFilterKeyName = useMemo(() => {
        var _a, _b, _c;
        if (!activeFilters) {
            return undefined;
        }
        const activeSizeFiltersKey = Object.keys(activeFilters).filter(activeFilterKey => {
            var _a, _b, _c;
            return ((_a = activeFilters[activeFilterKey]) === null || _a === void 0 ? void 0 : _a.filterContentType) === FilterContentTypes.SIZE &&
                ((_c = (_b = activeFilters[activeFilterKey]) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.length);
        });
        return activeSizeFiltersKey[0] ? (_c = (_b = (_a = activeFilters[activeSizeFiltersKey[0]]) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.filterKeyName : undefined;
    }, [activeFilters]);
    useEffect(() => {
        // @TODO lister redux deprecation
        dispatch(listerActions.createInitializeAction());
        dispatch(analyticsActions.productSearchPersonalization({
            personalized: Boolean(data === null || data === void 0 ? void 0 : data.personalized),
            traits: (data === null || data === void 0 ? void 0 : data.traits) || [],
        }));
        if (pageInfo.isCategoryPage || pageInfo.isBrandAsCategoryPage || pageInfo.isBrandPage) {
            dispatch(analyticsActions.listerResults((data === null || data === void 0 ? void 0 : data.itemCount) || 0));
        }
        dispatch(analyticsActions.listerViewProductList(itemsToShow, currency, pageInfo.isSearchPage ? Events.VIEW_SEARCH_RESULTS : Events.VIEW_PRODUCT_LIST, urlState.q));
    }, []);
    useEffect(() => {
        if (isClient) {
            MonetateUtil.pushListerEvent(itemsToShow === null || itemsToShow === void 0 ? void 0 : itemsToShow.filter(item => item.productId));
        }
    }, [isClient]);
    const contentBlocksToShow = (contentBlocks === null || contentBlocks === void 0 ? void 0 : contentBlocks.filter(contentBlock => !!contentBlock.linkPath && !!contentBlock.visibleInRow && !!contentBlock.content)) || [];
    const updateCompareList = (compareProduct) => dispatch(compareActions.createUpdateOnListerAction(compareProduct));
    return (_jsx(ProductListerGrid, { isLoading: isFetching && !isFetched, items: itemsToShow, updateCompareList: updateCompareList, contentBlocks: contentBlocksToShow, singleActiveSizeFilterKeyName: singleActiveSizeFilterKeyName }));
};
